import { h } from "preact";
import { useState, useEffect } from "preact/hooks";
import { Box, Button, DialogActions, DialogContent, Dialog, DialogTitle, Typography } from "@mui/material";

export default function DeleteRealEstatePicturesDialog(props) {
	const [form, setForm] = useState({ confirm: "" });
	const [disabled, setDisabled] = useState(true);
	const handleClose = () => {
		props.onClose();
	};
	const handleChange = (event) => {
		setForm({ ...form, [event.target.name]: event.target.value });
	};

	useEffect(() => {
		console.log(form.confirm, form.confirm === "supprimer " + props.state.name);
		setDisabled(!(form.confirm === "supprimer " + props.state.name));
	}, [form]);
	const handleSubmitDeletePicture = () => {
		const requestOptions = {
			method: "GET",
			headers: { "Content-Type": "application/json" },
		};
		fetch("/api/8e7fc288ce524668b0caabc3765a96ba/" + props.state.params.uid, requestOptions)
			.then((response) => {
				return response.json();
			})
			.then((res) => {
				switch (res.res) {
					case "ok":

						window.location.reload();
						break;

					case "err":
						break;
					default:
						break;
				}
			});
	};
	return (
		<Dialog onClose={handleClose} aria-labelledby="add-user-dialog" open={props.state.opened} maxWidth="md" fullWidth={false}>
			<DialogTitle id="add-user-dialog">Suppression d'une photo</DialogTitle>
			<DialogContent dividers>
				<Typography variant="body1" gutterBottom>
					Vous souhaitez supprimer cette photo ?
				</Typography>
				{/* {state.cnt == 1 && <Typography >Attention: c'est la seule photo du bien</Typography>} */}
			</DialogContent>

			<DialogActions>
				<Box display="flex" justifyContent="space-between" alignItems="space-between" style="width: 100%;">
					<Box>
						<Button variant="outlined" onClick={handleClose}>
							Annuler
						</Button>
					</Box>
					<Box>
						<Button
							variant="contained"
							onClick={handleSubmitDeletePicture}

							disabled={false}
						>
							Supprimer
						</Button>
					</Box>
				</Box>
			</DialogActions>
		</Dialog>
	);
}
